<template>
    <modal
    name="modal-home-category"
    height="auto"
    width="70%"
    class="customSurveyModal"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="closed">

      <div class="row7">
        <header class="modalHeader flex flexAlignS homeCategoryStepHead">
          <div class="title">
            <div class="flex">
                <p class="step">1단계</p>
                <p class="steptitle">고령친화제품</p>
            </div>
            <p class="infoTxt">
                실내·외를 선택해주세요.
            </p>
          </div>
          <button @click="onClickCancel"></button>
        </header>
      </div>

      <div class="homeCategorybody">
        <div class="indoor outside">
            <button v-for="(place, index) in placeList" :key="index" :class="[{indoorBtn: place.IN_OUT === '실내'}, {outsideBtn: place.IN_OUT === '실내'}]" @click="goSelectProductDetailCategory(place.IN_OUT)">
                <figure>
                    <img :src="require('../../assets/images/cmmnMain/CategoryStep/'+place.IMAGE)" v-bind:alt="place.IMAGE">
                    <figcaption>{{place.IN_OUT}}</figcaption>
                </figure>
            </button>

            <ModalHomeCategoryStep2 v-if="isShowModalHomeCategoryStep2" @modal-closed='handleModalClosed'/>
            <ModalHomeCategoryStep2Outside v-if="isShowModalHomeCategoryStep2Outside" @modal-closed='handleModalClosed'/>
        </div>
      </div>
      
      <div class="modalFooterBtn btnBox">
        <button class="redBtn" @click="onClickCancel">닫 기</button>
      </div>
      
    </modal>
</template>

<script>
import ModalHomeCategoryStep2 from '@/components/category/ModalHomeCategoryStep2'
import ModalHomeCategoryStep2Outside from '@/components/category/ModalHomeCategoryStep2Outside'
import { mapActions } from 'vuex'

export default {
    name: 'ModalHomeCategory',
    components: {
        ModalHomeCategoryStep2,
        ModalHomeCategoryStep2Outside
    },
    data(){
        return {
            modalResult: false,
            isShowModalHomeCategoryStep2: false,
            isShowModalHomeCategoryStep2Outside: false,
            placeList : [],
            inOut : '',
        }
    },
    computed:{
    },
    mounted(){
        this.show();

        this.requestGetInOutDetailList({})
        .then((response) => {
            
            this.placeList = response.data;
        })
        .catch(()=>{
            this.$alert('알림', '데이터를 가져올 수 없습니다.')  
        })
    },
	methods:{
		...mapActions('category', [
            'requestGetInOutDetailList'
        ]),
        goSelectProductDetailCategory(inOut){
            this.inOut = inOut;
            if(this.inOut == "실내"){
                this.isShowModalHomeCategoryStep2 = true;
            } else if (this.inOut == "실외"){
                this.isShowModalHomeCategoryStep2Outside = true;
            }
        },
        show(){
            this.$modal.show('modal-home-category')
        },
        hide(){
            this.$modal.hide('modal-home-category')
        },
        beforeOpen(){
        },
        closed(){
            this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
        },
        onClickCancel(){
            this.hide()
        },
        handleModalClosed(value){
            if(value === ModalHomeCategoryStep2.name){
                this.isShowModalHomeCategoryStep2 = false
            }
            if(value === ModalHomeCategoryStep2Outside.name){
                this.isShowModalHomeCategoryStep2Outside = false
            }
        }
    },
    
}
</script>